import {
  Box,
  IconButton,
  Input,
  Stack,
  Text,
  useTheme,
} from '@ltvco/refresh-lib/theme';
import { Send, Refresh } from '@mui/icons-material';

import {
  chipStyles,
  containerStyles,
  inputStyles,
  sendButtonStyles,
} from './components';

export function SearchpalChatbotInput({
  inputValue,
  handleInputChange,
  handleKeyDown,
  disabledConditions,
  onSend,
  showNotification,
  notificationContent,
  handleReset,
}: {
  inputValue: string;
  // eslint-disable-next-line no-unused-vars
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  // eslint-disable-next-line no-unused-vars
  handleKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  disabledConditions: boolean;
  onSend?: () => void;
  showNotification?: boolean;
  notificationContent?: string | number;
  handleReset: () => void;
}) {
  const theme = useTheme();
  return (
    <>
      <Box sx={containerStyles}>
        <Input
          fullWidth
          multiline
          data-testid="input-message"
          value={inputValue}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          placeholder="Type additional details here..."
          disabled={disabledConditions}
          sx={inputStyles}
        />
        {onSend && (
          <Box sx={{ position: 'absolute', right: 10 }}>
            {showNotification && (
              <Box sx={chipStyles}>{notificationContent}</Box>
            )}
            <IconButton
              onClick={onSend}
              disabled={disabledConditions || !inputValue.trim()}
              sx={sendButtonStyles}
            >
              <Send />
            </IconButton>
          </Box>
        )}
      </Box>
      <Stack direction="column" gap={2} pb={2}>
        <Text
          variant="caption"
          color="text.secondary"
          sx={{
            fontStyle: 'italic',
            m: 0,
          }}
        >
          Example: "35 years old, lives in Boston, works at Tech Corp"
        </Text>
        <Text
          variant="h6"
          color="text.secondary"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            cursor: 'pointer',
            fontWeight: 'bold',
            fontSize: '14px',
            color: theme.palette.primary.main,
            '&:hover': {
              textDecoration: 'none',
            },
          }}
        >
          <Refresh
            sx={{ fontSize: '20px', ml: 2, mr: 1 }}
            onClick={handleReset}
          />{' '}
          Clear & Start Over
        </Text>
      </Stack>
    </>
  );
}
